(() => {
  'use strict';

  const popup = document.querySelector('[data-radiance-popup]');
  if (!popup) return;

  const dialog = popup.querySelector('.radiance-popup__dialog');
  const questionStep = popup.querySelector('[data-step="question"]');
  const formStep = popup.querySelector('[data-step="form"]');
  const successStep = popup.querySelector('[data-step="success"]');
  const options = popup.querySelectorAll('[data-interest]');
  const form = popup.querySelector('form');
  const emailInput = popup.querySelector('input[type="email"]');
  const tagsInput = popup.querySelector('[data-interest-tags]');
  const noteInput = popup.querySelector('[data-interest-note]');
  const formStatus = popup.querySelector('[data-form-status]');
  const closeButtons = popup.querySelectorAll('[data-popup-close]');
  const backButton = popup.querySelector('[data-popup-back]');
  const progress = popup.querySelectorAll('[data-progress-step]');
  const personalizedCopy = popup.querySelector('[data-personalized-copy]');
  const frequencyDays = Number(popup.dataset.frequencyDays || 7);
  const storageKey = 'radiance-signup-popup-last-seen';
  const completedKey = 'radiance-signup-popup-completed';
  let lastFocusedElement = null;

  const copyByInterest = {
    capelli: 'La tua routine capelli parte da qui. Ti invieremo consigli e novità pensati per prenderti cura dei tuoi capelli con più consapevolezza.',
    pelle_viso: 'La tua pelle merita una routine pensata per lei. Ti aiuteremo a scoprire ciò che può valorizzarla giorno dopo giorno.',
    corpo: 'Il benessere è fatto di piccoli gesti. Riceverai ispirazione e consigli per rendere la tua routine corpo ancora più speciale.',
    scoperta: 'Non sai ancora da dove iniziare? Ti accompagneremo con idee semplici e consigli per trovare il tuo punto di partenza.'
  };

  function isMobileAllowed() {
    return popup.dataset.showOnMobile !== 'false' || window.matchMedia('(min-width: 641px)').matches;
  }

  function canShow() {
    if (!isMobileAllowed() || localStorage.getItem(completedKey) === 'true') return false;
    const lastSeen = Number(localStorage.getItem(storageKey) || 0);
    return !lastSeen || (Date.now() - lastSeen) >= frequencyDays * 86400000;
  }

  function openPopup() {
    if (!canShow()) return;
    lastFocusedElement = document.activeElement;
    localStorage.setItem(storageKey, String(Date.now()));
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('radiance-popup-is-open');
    window.setTimeout(() => dialog.focus(), 50);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('radiance-popup-is-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
  }

  function showStep(step) {
    questionStep.hidden = step !== 'question';
    formStep.hidden = step !== 'form';
    successStep.hidden = step !== 'success';
    progress.forEach((item) => item.classList.toggle('is-active', item.dataset.progressStep === step));
    window.setTimeout(() => {
      const target = step === 'question' ? questionStep : step === 'form' ? formStep : successStep;
      const focusTarget = target.querySelector('input, button');
      if (focusTarget) focusTarget.focus();
    }, 30);
  }

  options.forEach((option) => {
    option.addEventListener('click', () => {
      const interest = option.dataset.interest;
      const label = option.querySelector('.radiance-popup__option-title')?.textContent.trim() || interest;
      if (tagsInput) tagsInput.value = `radiance-popup,interest-${interest}`;
      if (noteInput) noteInput.value = `Interesse: ${label}`;
      if (personalizedCopy && copyByInterest[interest]) personalizedCopy.textContent = copyByInterest[interest];
      showStep('form');
    });
  });

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));
  if (backButton) backButton.addEventListener('click', () => showStep('question'));

  document.addEventListener('keydown', (event) => {
    if (!popup.classList.contains('is-open')) return;
    if (event.key === 'Escape') closePopup();
    if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('button, input, a[href]')].filter((el) => !el.closest('[hidden]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  if (form) {
    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      // Shopify gestisce l'invio reale del form. La schermata di successo viene
      // mostrata solo dopo il ritorno senza errori dal browser/tema.
      // Per temi che restano sulla stessa pagina, il submit intercettato dal tema
      // può usare questo evento per passare direttamente alla conferma.
    });
  }

  if (formStatus && formStatus.value === 'true') {
    localStorage.setItem(completedKey, 'true');
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('radiance-popup-is-open');
    showStep('success');
  }

  const delay = Number(popup.dataset.popupDelay || 10000);
  if (delay === 0) openPopup();
  else window.setTimeout(openPopup, delay);
})();
